import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export function FormSuccess() {
    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        // Delay content animation for smooth transition
        const timer = setTimeout(() => {
            setShowContent(true);
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="quote-success-wrapper row justify-content-center align-items-center">
            <div className="col-12 col-xl-10 success">
                <div
                    className={`success-content ${showContent ? 'show' : ''}`}
                    style={{
                        opacity: showContent ? 1 : 0,
                        transform: showContent ? 'translateY(0)' : 'translateY(20px)',
                        transition: 'all 0.6s ease-out',
                    }}
                >
                    {/* Success Icon */}
                    <div
                        className="success-icon-wrapper mb-4"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '2rem',
                        }}
                    >
                        <div
                            style={{
                                width: '80px',
                                height: '80px',
                                background: 'rgb(0, 165, 180)',
                                boxShadow: '0 8px 25px rgba(0, 165, 180, 0.25)',
                                animation: showContent ? 'pulseScale 0.6s ease-out' : 'none',
                            }}
                            className="d-flex justify-content-center align-items-center rounded-circle"
                        >
                            <FontAwesomeIcon
                                icon={faCheck}
                                style={{
                                    color: 'white',
                                    fontSize: '2.5rem',
                                    animation: showContent ? 'checkmarkDraw 0.8s ease-out 0.3s both' : 'none',
                                }}
                            />
                        </div>
                    </div>

                    {/* Success Title */}
                    <h1
                        className="success-title mb-3"
                        style={{
                            fontSize: '2.5rem',
                            fontWeight: '700',
                            color: '#00a5b4',
                            textAlign: 'center',
                            animation: showContent ? 'fadeInUp 0.6s ease-out 0.2s both' : 'none',
                        }}
                    >
                        Thank You!
                    </h1>

                    {/* Success Subtitle */}
                    {/* <h6
                        className="success-subtitle mb-4"
                        style={{
                            color: '#333',
                            fontSize: '1.25rem',
                            fontWeight: '500',
                            textAlign: 'center',
                            animation: showContent ? 'fadeInUp 0.6s ease-out 0.3s both' : 'none',
                        }}
                    >
                        Your request has been submitted
                    </h6> */}
                </div>
            </div>
        </div>
    );
}

export default FormSuccess;
